module.exports = __webpack_public_path__ + "img/DSM.d9136796.png";